// Chat.js
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../api/axios';
import EventTypeMessage from './EventTypeMessage';
import VenueList from './venue/VenueList';

function getSessionCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

const generateUrlSafeId = (length = 21) => {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);

  return btoa(String.fromCharCode(...array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')
    .slice(0, length);
};

function Ask() {
  const [results, setResults] = useState([]);
  const [input, setInput] = useState('');
  const [sessionId, setSessionId] = useState('');
  const [eventType, setEventType] = useState('');
  const messagesEndRef = useRef(null);
  const [initialPage, setInitialPage] = useState(1);
  // Add these state variables at the top of your component
  const [loading, setLoading] = useState(false);
  const [currentPollingInterval, setCurrentPollingInterval] = useState(null);

  //const sessionId = getSessionCookie('sessionId');
  //const sessionId = generateUrlSafeId();
	//

  // Add cleanup on component unmount
  useEffect(() => {
    return () => {
      if (currentPollingInterval) {
        clearInterval(currentPollingInterval);
      }
    };
  }, [currentPollingInterval]);

  // useEffect(() => {
  //   const sessionId = localStorage.getItem('sessionId');
  //   if (sessionId) {
  //     setSessionId(sessionId);
  //   } else {
  //     const newId = generateUrlSafeId();
  //     localStorage.setItem('sessionId', newId);
  //     setSessionId(newId);
  //   }
  // }, [sessionId]);

  useEffect(() => {
    const isPageRefresh = performance.getEntriesByType('navigation')[0].type === 'reload';
    const existingId = localStorage.getItem('sessionId');
    
    if (isPageRefresh || !existingId) {
      const newId = generateUrlSafeId();
      localStorage.setItem('sessionId', newId);
      setSessionId(newId);
    } else {
      setSessionId(existingId);
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  const sendMessage = async () => {
    setLoading(true);
    if (input.trim() === '') return;

    // Add the user message to the chat

    try {
      // Replace with your Dialogflow API endpoint
      const response = await axiosInstance.post('/asks', {
        message: input,
        session_id: sessionId
      });

      // Get the job ID from the response
      const jobId = response.data.job_id;
    
      // Start polling for results
      pollForResults(jobId);
    
    } catch (error) {
      console.error('Error sending message:', error);
    } finally {
      
    }
  };

  // Add this new function for polling
const pollForResults = async (jobId) => {
  // Create a polling interval
  const pollingInterval = setInterval(async () => {
    try {
      // Check the job status
      const statusResponse = await axiosInstance.get(`/job_status/${jobId}`);
      
      // Check if the job is completed
      if (statusResponse.data.status === 'completed') {
        // Clear the polling interval
        clearInterval(pollingInterval);
        
        // Update the UI with the results
        const results = statusResponse.data.result.processed_items;
        setResults(results);
        setInitialPage(0);
        setLoading(false);
      } else if (statusResponse.data.status === 'failed') {
        // Handle failed job
        clearInterval(pollingInterval);
        console.error('Job failed:', statusResponse.data.error);
        setLoading(false);
      }
      // If still processing, continue polling
      
    } catch (error) {
      console.error('Error polling for results:', error);
      clearInterval(pollingInterval);
      setLoading(false);
    }
  }, 2000); // Poll every 2 seconds
  
  // Store the interval ID for cleanup
  setCurrentPollingInterval(pollingInterval);
};
  return (
    <div className="h-[500px] overflow-y-auto p-4">
      <div className="p-4 border-t border-gray-200">
        <div className="flex gap-2">
        <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="What kind of venue you want? Provide a detailed requirement."
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <button 
            onClick={sendMessage}
            className="px-6 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors"
          >
            Find Venue
          </button>
        </div>
      </div>
      {initialPage === 0 && 
        <div className="w-full bg-white rounded-lg shadow-lg border border-gray-200">
            <VenueList venues={results} />
	          <div ref={messagesEndRef}></div> 
        </div> 
      }
     
      {loading && (
      <div className="loading-indicator">
        <p>Processing your request...</p>
        <div className="spinner"></div>
     </div>
     )}
   </div>
  );
}

export default Ask;
